module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customers"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-condition"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v(_vm._s(_vm.$t('Views.Customers.checkbox.all')))]), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checkList),
      callback: function($$v) {
        _vm.checkList = $$v
      },
      expression: "checkList"
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.activeCustomers', 0)))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.activeCustomers', 1)))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.activeCustomers', 2)))])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "4"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.frequencyCustomers', 0)))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "5"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.frequencyCustomers', 1)))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "6"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.frequencyCustomers', 2)))])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "7"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.contributionCustomers', 0)))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "8"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.contributionCustomers', 1)))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "9"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.contributionCustomers', 2)))])], 1)])], 1)])]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "btn btn-success btn-flat",
    on: {
      "click": _vm.searchByCondition
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.confirm')))]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-danger btn-flat ",
    on: {
      "click": _vm.clearSelectors
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.clear')))])])])])], 1)])]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sl-body"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "id",
      "label": _vm.$t('Views.Customers.table.id'),
      "sortable": "",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "name",
      "label": _vm.$t('Views.Customers.table.name'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "phone",
      "label": _vm.$t('Views.Customers.table.mobile'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "gender",
      "label": _vm.$t('Views.Customers.table.gender')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "joinTime",
      "label": _vm.$t('Views.Customers.table.joinDate')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "totalAmount",
      "label": _vm.$t('Views.Customers.table.totalSpending')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "lastVisitTime",
      "label": _vm.$t('Views.Customers.table.lastVisitDate')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "avgAmount",
      "label": _vm.$t('Views.Customers.table.averageSpending')
    }
  })], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-329177aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/customers/customers.vue
// module id = 1095
// module chunks = 1